import { getString } from './utils/env';

export type Environment = {
  readonly MODE: string;
  readonly RUNTIME_ENV: string;
  readonly APP_VERSION: string;
  readonly API_URL: string;
  readonly FULLSTORY_ORG_ID: string;
  readonly SENTRY_DSN: string;
  readonly LAUNCH_DARKLY_CLIENT_ID: string;
  readonly AUTH_IUM_ISSUER_URL: string;
  readonly AUTH_IUM_CLIENT_ID: string;
  readonly MONOLITH_URL: string;
  readonly SOFTPHONE_MFE_URL: string;
  readonly ENTERPRISE_HUB_URL: string;
  readonly BRAZE_API_KEY: string;
  readonly BRAZE_SDK_ENDPOINT: string;
  readonly HELP_CENTER_URL: string;
  readonly AIS_API_URL: string;
  readonly PENDO_API_KEY: string;
};

/**
 * The following parses the environment variables and sets the default values
 * for the application.
 *
 * NOTE: The helper functions cannot be simplified down to only taking a string
 * because the vite preprocessor is looking for the import.meta.env.XXX to
 * determine the environment variables.
 */
const environment: Environment = {
  MODE: getString(import.meta.env.MODE, 'MODE'),
  RUNTIME_ENV: getString(import.meta.env.VITE_RUNTIME_ENV, 'VITE_RUNTIME_ENV'),
  APP_VERSION: getString(import.meta.env.VITE_APP_VERSION, 'VITE_APP_VERSION'),
  API_URL: getString(import.meta.env.VITE_API_URL, 'VITE_API_URL'),
  FULLSTORY_ORG_ID: getString(
    import.meta.env.VITE_FULLSTORY_ORG_ID,
    'VITE_FULLSTORY_ORG_ID',
  ),
  SENTRY_DSN: getString(import.meta.env.VITE_SENTRY_DSN, 'VITE_SENTRY_DSN'),
  LAUNCH_DARKLY_CLIENT_ID: getString(
    import.meta.env.VITE_LAUNCH_DARKLY_CLIENT_ID,
    'VITE_LAUNCH_DARKLY_CLIENT_ID',
  ),
  AUTH_IUM_ISSUER_URL: getString(
    import.meta.env.VITE_AUTH_IUM_ISSUER_URL,
    'VITE_AUTH_IUM_ISSUER_URL',
  ),
  AUTH_IUM_CLIENT_ID: getString(
    import.meta.env.VITE_AUTH_IUM_CLIENT_ID,
    'VITE_AUTH_IUM_CLIENT_ID',
    'default-client-id',
  ),
  MONOLITH_URL: getString(
    import.meta.env.VITE_MONOLITH_URL,
    'VITE_MONOLITH_URL',
  ),
  SOFTPHONE_MFE_URL: getString(
    import.meta.env.VITE_SOFTPHONE_MFE_URL,
    'VITE_SOFTPHONE_MFE_URL',
  ),
  ENTERPRISE_HUB_URL: getString(
    import.meta.env.VITE_ENTERPRISE_HUB_URL,
    'VITE_ENTERPRISE_HUB_URL',
  ),
  BRAZE_API_KEY: getString(
    import.meta.env.VITE_BRAZE_API_KEY,
    'VITE_BRAZE_API_KEY',
  ),
  BRAZE_SDK_ENDPOINT: getString(
    import.meta.env.VITE_BRAZE_SDK_ENDPOINT,
    'VITE_BRAZE_SDK_ENDPOINT',
  ),
  PENDO_API_KEY: getString(
    import.meta.env.VITE_PENDO_API_KEY,
    'VITE_PENDO_API_KEY',
  ),
  HELP_CENTER_URL: getString(
    import.meta.env.VITE_HELP_CENTER_URL,
    'VITE_HELP_CENTER_URL',
  ),
  AIS_API_URL: getString(import.meta.env.VITE_AIS_API_URL, 'VITE_AIS_API_URL'),
};

export default environment;
